import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'company_notice_edit',
  components: {
    AppHeader
  },
  data () {
    return {
      company_notices: {},
      notice_title: '',
      notice_content: '',
      notice_start_date: '',
      notice_end_date: '',
      is_mail_delivery: true,
      savingFlag: false,
      getCompanyNoticeFlg: false
    }
  },
  created () {
    this.getCompanyNotice()
  },
  computed: {
    startDate () {
      return DayJs(this.notice_start_date).format('YYYY-MM-DD')
    },
    endDate () {
      return DayJs(this.notice_end_date).format('YYYY-MM-DD')
    },
    validation () {
      const validation = {
        notice_title: true,
        notice_content: true,
        notice_start_date: true
      }
      // 未公開
      if (this.releaseStatus === 0) {
        validation.notice_title = !!this.notice_title
        validation.notice_content = !!this.notice_content
        validation.notice_start_date = !!this.notice_start_date
      }
      // 通知期間中
      if (this.releaseStatus === 1) {
        validation.notice_title = !!this.notice_title
        validation.notice_content = !!this.notice_content
      }
      // 通知期間終了
      if (this.releaseStatus === 2) {
        validation.notice_title = !!this.notice_title
        validation.notice_content = !!this.notice_content
      }
      return validation
    },
    validationAll () {
      if (!this.validation.notice_title) return false
      if (!this.validation.notice_content) return false
      if (!this.validation.notice_start_date) return false
      if (this.validationNoticeStartDate) return false
      if (this.validationNoticeEndDate) return false
      return true
    },
    validationNoticeStartDate () {

      // 未公開のときのみ実施
      if (this.releaseStatus !== 0) return ''

      const today = DayJs(new Date()).format('YYYY-MM-DD')
      if (!DayJs(today).isBefore(this.startDate)) {
        return '明日以降の日付を選択してください。'
      }
    },
    validationNoticeEndDate () {

      // 通達表示開始日の後のみ登録可能とするので入力チェックも
      // 通達表示開始日が入力されているときのみ実施する
      if (!this.validation.notice_start_date) return ''

      // 未公開、通知期間中のときのみ実施
      if (this.releaseStatus === 2) return ''

      const today = DayJs(new Date()).format('YYYY-MM-DD')
      if (!this.notice_end_date) {
        return '必須項目です。'
      }
      if (!DayJs(today).isBefore(this.endDate)) {
        return '明日以降の日付を選択してください。'
      }
      if (!(this.startDate < this.endDate)) {
        return '通知期間終了日は通達表示開始日より後の日付を入力してください。'
      }
    },
    releaseStatus () {
      // 状態
      const today = DayJs(new Date()).format('YYYY-MM-DD')
      const startDay = DayJs(this.company_notices.notice_start_date).format('YYYY-MM-DD')
      const endDay = DayJs(this.company_notices.notice_end_date).format('YYYY-MM-DD')
      // 未公開
      if (DayJs(today).isBefore(startDay)) {
        return 0
      }
      // 通知期間終了
      if (DayJs(endDay).isBefore(today)) {
        return 2
      }
      // 通知期間中
      return 1
    }
  },
  methods: {
    async getCompanyNotice () {
      // 詳細情報取得
      const res = await this.$store.dispatch('GET_COMPANY_NOTICE', {id: this.$route.params.company_notice_id})
      .catch(err => {
        console.error(err)
        return
      })
      this.company_notices = res.company_notices
      this.notice_title = this.company_notices.notice_title
      this.notice_content = this.company_notices.notice_content
      this.notice_start_date = this.company_notices.notice_start_date
      this.notice_end_date = this.company_notices.notice_end_date
      this.is_mail_delivery = (this.company_notices.is_mail_delivery === 1)

      this.getCompanyNoticeFlg = true
    },
    async onClickSave () {
      // 保存時連打対策
      if (this.savingFlag) return false
      this.savingFlag = true
      
      // 保存処理
      await this.$store.dispatch('UPDATE_COMPANY_NOTICE', {
        data: {
          id: this.$route.params.company_notice_id,
          notice_title: this.notice_title,
          notice_content: this.notice_content,
          notice_start_date: this.startDate,
          notice_end_date: this.endDate,
          is_mail_delivery: (this.is_mail_delivery) ? 1 : 0
        }
      })
      .catch(err => {
        console.error(err)
        return
      })
      this.$router.push('/company_notice_list')
    },
    onClickCancel: function () {
      this.$router.push('/company_notice_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/company-notice-edit.js